import React, { memo } from 'react';
import { StockChart } from '@components';

const FullScreenChart = memo(({ data, width, ...rest }) => {
  const noData =
    !Array.isArray(data?.closingPriceList) ||
    data.closingPriceList.length === 0;
  return (
    <div className="content">
      <div
        className="name"
        style={{
          opacity: noData ? 0 : 1,
          userSelect: noData ? 'none' : '',
        }}
      >
        {data.companyName || ''}
      </div>
      <div className="chart" style={{ width }}>
        <StockChart expand={true} data={data} {...rest} />
      </div>
    </div>
  );
});

function FullScreen(props) {
  const {
    selectedRange,
    changeRange,
    data: { buyer, target },
    ...rest
  } = props;

  const width = (document.body.clientWidth - 84) / 2 - 50;
  return (
    <div className="full-screen-chart-wrapper">
      <FullScreenChart
        data={buyer}
        onRangeSelected={changeRange}
        selected={selectedRange}
        width={width}
        {...rest}
      />
      <FullScreenChart
        data={target}
        onRangeSelected={changeRange}
        selected={selectedRange}
        width={width}
        {...rest}
      />
    </div>
  );
}

export default FullScreen;
